import React from 'react';
import PaySchoolFees from '../components/PaySchoolFees';
import MainLayout from '../components/MainLayout';

const SchoolFeesTrack = () => {
  return (
    <MainLayout>
      <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-md-8">
            <PaySchoolFees />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default SchoolFeesTrack;
